<!-- 公服企业办理表格 -->
<template>
    <div class="tablebox box box_v">
        <Row class="box">
            <Col span="3" class="title">排名</Col>
            <Col span="8" class="title">社区</Col>
            <Col span="4" class="title">参与度</Col>
            <Col span="3" class="title">发布</Col>
            <Col span="3" class="title">评论</Col>
            <Col span="3" class="title">点赞</Col>
        </Row>
        <div class="nodataBox box_f1" v-if="nodata">暂无数据</div>
        <Row v-for="(item,index) in communitydata" :key="item.id"  class="box_f1 table2row" v-else>

            <Col span="3" class="content rankbg" :class="item.bgclass" v-if="index<3"></Col>
            <Col span="3" class="content"  v-else>{{index+1}}</Col>
            <Col span="8" class="content">{{item.communityName}}</Col>
            <Col span="4" class="content">{{item.percentage}}%</Col>
            <Col span="3" class="content">{{item.publishNum}}</Col>
            <Col span="3" class="content">{{item.commentNum}}</Col>
            <Col span="3" class="content">{{item.likeNum}}</Col>

        </Row>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
//:style="{backgroundImage:item.bg}"
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            communitydata:[],
            nodata:false
        };
    },
  props:{
    token:{
      type:String,
      default: ''
    }
  },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            var url = this.urlobj.communityActive

          this.$get(url,{},{
            token:this.token || this.$store.state.access_token
          }).then(res => {
                if (res.isSucceed) {
                    let data = res.rows
                    if(!data.length){
                        this.nodata = true;
                        return
                    }
                    data.sort(this.$util.compare('percentage'))
                    data = data.length>4?data.slice(0,4):data
                  if (this.token) {
                    data = data.slice(0,5)
                  }
                    this.communitydata = data.map((item,index)=>{
                        return {
                            communityName:item.communityName.split('社区')[0],
                            percentage:item.percentage,
                            publishNum:item.publishNum,
                            commentNum:item.commentNum,
                            likeNum:item.likeNum,
                            bgclass:'bg'+index
                            //bg:index<3?"url('../../../assets/images/monitor/1.png')":"",
                        }
                    })

                } else {

                }
            }).catch(e => {

            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getData()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.tablebox{
    font-size: 12px;
    color:#b0b0b0;
    height: 100%;
    margin:0 10px;
}
.title{
    color:#91b1fc;
    text-align: center;
}
.content{
    text-align: center
}
.organ{
    color:#f6ab00;
}
.rankbg{
    height:18px;
    background-size: 15px 100%;
    background-position: center;
    background-repeat: no-repeat;
}
.bg0{
    background-image: url('../../../assets/images/monitor/1.png')
}
.bg1{
    background-image: url('../../../assets/images/monitor/2.png')
}
.bg2{
    background-image: url('../../../assets/images/monitor/3.png')
}
.nodataBox{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #b0b0b0;
}
.table2row{
    display:flex;
    align-items: center
}
</style>
